declare global {
  interface Window {
    getHost: () => string
  }
}

if (!window.getHost) {
  window.getHost = () => {
    return window.location.host
  }
}

export function baseHost(host?: string | null): string {
  let _host = host

  if (!_host) {
    _host = window.getHost()
  }
  const match = _host.match(/\.([a-z][^.]+\.[a-z]+(:\d+)?)$/i)
  if (match) {
    return match[1]
  }
  return _host
}

export function isBaseHost(url: string): boolean {
  const _url = String(url)
  let host

  const match = _url.match(/(?:https?:)?\/\/([^/]+)/)
  if (match) {
    host = match[1]
  }
  if (host) {
    const currentHost = baseHost()
    if (
      baseHost(host) !== currentHost ||
      host.endsWith(`.proxy.${currentHost}`)
    ) {
      return false
    }
  }
  return true
}
